import httpRequest from "../utils/axios.js";

export function listTodayRedPacketDetailApi(id) {
  var url = `api/v1.0/user/wechat/red-packet/${id}`;
  return httpRequest.fetchGet(url);
}

export function wechatRedPacketExchangeApi(data) {
  var url = `api/v1.0/user/wechat/red-packet`;
  return httpRequest.fetchPost(url, data);
}